
  export default {
    name: `AeqSubtitle`,
    props: {
      label: {
        type: String,
        default: ``
      },
      hint: {
        type: String,
        default: ``
      }
    },
    data() {
      return {}
    }
  }
